export default __webpack_public_path__ + "static/media/aiaw-policy-summary.9ea3f1b8.pdf";